import React from 'react';
import flagZhongo from '../../../../assets/flags/Zhongo.png';
import flagEurocorp from '../../../../assets/flags/Eurocorp.png';
import flagPetrolistan from '../../../../assets/flags/Petrolistan.png';
import flagVolgovie from '../../../../assets/flags/Volgovie.png';
import flagAutoristan from '../../../../assets/flags/Autoristan.png';
import flagSudica from '../../../../assets/flags/Sudica.png';
import flagNeoAtlas from '../../../../assets/flags/Neo Atlas.png';
import flagBricologia from '../../../../assets/flags/Bricologia.png';

const CountriesShowcaseSlide = ({ slide, slideKey, currentSlide, slidesLength }) => {
    const mainCountries = [
        { name: "Zhongo", flag: flagZhongo, color: "from-red-500/20 to-orange-500/20", borderColor: "border-red-400/50", desc: "L'Empire Technologique" },
        { name: "Eurocorp", flag: flagEurocorp, color: "from-blue-500/20 to-indigo-500/20", borderColor: "border-blue-400/50", desc: "La Fédération Économique" },
        { name: "Petrolistan", flag: flagPetrolistan, color: "from-yellow-500/20 to-amber-500/20", borderColor: "border-yellow-400/50", desc: "Le Sultanat Pétrolier" },
        { name: "Volgovie", flag: flagVolgovie, color: "from-slate-500/20 to-gray-500/20", borderColor: "border-slate-400/50", desc: "L'Héritière du Bloc" }
    ];

    const secondaryCountries = [
        { name: "Autoristan", flag: flagAutoristan, color: "from-emerald-500/15 to-teal-500/15", desc: "L'Autocratie Verte" },
        { name: "Sudica", flag: flagSudica, color: "from-lime-500/15 to-green-500/15", desc: "Le Laboratoire du Sud" },
        { name: "Neo Atlas", flag: flagNeoAtlas, color: "from-cyan-500/15 to-sky-500/15", desc: "L'Alliance Océanique" },
        { name: "Bricologia", flag: flagBricologia, color: "from-orange-500/15 to-rose-500/15", desc: "La Coalition Émergente" }
    ];

    return (
        <div key={slideKey} className="h-full p-8 flex flex-col justify-center relative overflow-hidden">
            {/* Background effects */}
            <div className="absolute inset-0">
                <div className="absolute inset-0 bg-gradient-to-br from-purple-900/20 via-blue-900/30 to-black" />
                <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-blue-500/10 rounded-full blur-3xl animate-pulse" />
                <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '2s' }} />
            </div>

            <div className="relative z-10">
                <h2 className="text-6xl pb-2 font-bold mb-2 bg-gradient-to-r from-blue-400 via-cyan-400 to-blue-400 bg-clip-text text-transparent animate-fade-in-up text-center">
                    {slide.title}
                </h2>
                <p className="text-2xl text-blue-200/60 mb-8 animate-fade-in-up stagger-1 text-center">
                    {slide.subtitle}
                </p>

                {/* Pays principaux - 4 grandes cartes */}
                <div className="grid grid-cols-4 gap-6 mb-6 max-w-6xl mx-auto">
                    {mainCountries.map((country, i) => (
                        <div key={country.name}
                            className={`bg-gradient-to-br ${country.color} backdrop-blur-sm border ${country.borderColor} rounded-2xl p-6 hover:scale-105 transition-all duration-300 group animate-fade-in-scale`}
                            style={{ animationDelay: `${i * 0.1}s`, opacity: 0 }}>
                            <div className="flex flex-col items-center">
                                <div className="w-24 h-24 rounded-xl bg-gradient-to-br from-slate-700 to-slate-800 p-2 mb-4 group-hover:shadow-lg group-hover:shadow-blue-500/20 transition-all">
                                    <img src={country.flag} alt={country.name} className="w-full h-full object-contain" />
                                </div>
                                <h3 className="text-3xl font-bold text-white mb-1">{country.name}</h3>
                                <p className="text-base text-slate-400 text-center">{country.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Pays secondaires - 4 petites cartes */}
                <div className="grid grid-cols-4 gap-4 max-w-4xl mx-auto">
                    {secondaryCountries.map((country, i) => (
                        <div key={country.name}
                            className={`bg-gradient-to-br ${country.color} backdrop-blur-sm border border-slate-600/30 rounded-xl p-4 hover:scale-105 hover:border-slate-500/50 transition-all duration-300 group animate-fade-in-scale`}
                            style={{ animationDelay: `${(i + 4) * 0.1}s`, opacity: 0 }}>
                            <div className="flex items-center gap-3">
                                <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-slate-700 to-slate-800 p-1.5 flex-shrink-0">
                                    <img src={country.flag} alt={country.name} className="w-full h-full object-contain" />
                                </div>
                                <div className="min-w-0">
                                    <h4 className="text-xl font-semibold text-white truncate">{country.name}</h4>
                                    <p className="text-sm text-slate-400 truncate">{country.desc}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CountriesShowcaseSlide;
